import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markDeliveryOrderAsCanceled = async ({ deliveryOrderId, notes }: { deliveryOrderId: string; notes: string }) => {
  const response = await mutationExecute({
    variables: {
      deliveryOrderId,
      notes,
    },
    mutation: graphql(`
      mutation MarkDeliveryOrderAsCanceled($deliveryOrderId: String!, $notes: String!) {
        markDeliveryOrderAsCanceled(deliveryOrderId: $deliveryOrderId, notes: $notes) {
          id
          status
        }
      }
    `),
  });

  return response.data?.markDeliveryOrderAsCanceled ?? null;
};
